import { useEffect } from "react";
import { useBlocker, useNavigate } from "react-router-dom";

type IsStartedState = {
  isStarted: boolean;
};

type Params<T> = {
  state: T;
  shouldBlock?: (pathname: string) => boolean;
  basePath: string;
};

export const useRedirect = <T extends IsStartedState>({
  state,
  shouldBlock = () => false,
  basePath,
}: Params<T>) => {
  const routerNavigate = useNavigate();

  useBlocker(({ location, retry }) => {
    if (!shouldBlock(location.pathname)) {
      retry();
    }
    return "Are you sure you want to leave this form?";
  }, state.isStarted);

  useEffect(() => {
    if (!state.isStarted) {
      routerNavigate(basePath, {
        replace: true,
      });
    }
  }, [state, routerNavigate, basePath]);
};
